var React = require('react');

function SuitcaseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.8 20.9444V19.3333H1.616L1.6 25.7778C1.6 27.5661 3.024 29 4.8 29H27.2C28.976 29 30.4 27.5661 30.4 25.7778V19.3333H19.2V20.9444H12.8ZM28.8 6.44444H22.384V3.22222L19.184 0H12.784L9.584 3.22222V6.44444H3.2C1.44 6.44444 0 7.89444 0 9.66667V14.5C0 16.2883 1.424 17.7222 3.2 17.7222H12.8V14.5H19.2V17.7222H28.8C30.56 17.7222 32 16.2722 32 14.5V9.66667C32 7.89444 30.56 6.44444 28.8 6.44444ZM19.2 6.44444H12.8V3.22222H19.2V6.44444Z"}));
}

SuitcaseInline.defaultProps = {"width":"32","height":"29","viewBox":"0 0 32 29","fill":"none"};

module.exports = SuitcaseInline;

SuitcaseInline.default = SuitcaseInline;
